<template>
    <v-row no-gutters justify="end" justify-xl="center" align="center">
        <v-col cols="auto" class="line-height-1">
            <v-btn text x-small color="grey-6" to="/center">
                <span class="font-weight-regular">고객센터</span>
            </v-btn>
        </v-col>
        <v-col cols="auto"><span class="menu-line"></span></v-col>
        <v-col cols="auto" class="line-height-1">
            <v-btn text x-small color="grey-6" to="/form/inquiry-partner">
                <span class="font-weight-regular">기업회원 채용지원</span>
            </v-btn>
        </v-col>
        <template v-if="accessToken">
            <v-col cols="auto"><span class="menu-line"></span></v-col>
            <v-col cols="auto" class="line-height-1">
                <v-btn text x-small color="grey-6" to="/mypage/question">
                    <span class="font-weight-regular">문의하기</span>
                </v-btn>
            </v-col>
        </template>
    </v-row>
</template>

<script>
export default {
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
};
</script>
<style lang="scss" scoped>
</style>